import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RmvdDatePipeModule } from '../../pipes/rmvdDate.pipe';
import { ActionMenuComponentModule } from '../action-menu/action-menu.component.module';
import { DataObjectIconComponentModule } from '../dataobject-icon/dataobject-icon.component';
import { TimeseriesPreviewComponentModule } from '../timeseries-preview/timeseries-preview.component.module';
import { EscalatedForwardCurveAsOfDatePreviewComponent } from './escalated-forwardcurve-asofdate-preview.component';

@NgModule({
  declarations: [EscalatedForwardCurveAsOfDatePreviewComponent],
  exports: [EscalatedForwardCurveAsOfDatePreviewComponent],
  imports: [
    CommonModule,
    ActionMenuComponentModule,
    DataObjectIconComponentModule,
    TimeseriesPreviewComponentModule,
    RmvdDatePipeModule,
  ],
})
export class EscalatedForwardCurveAsOfDatePreviewComponentModule {}
